import Vue from 'vue'
import { securedAxiosInstance } from '../../backend/axios'
import _ from 'lodash'
import { now, createDate } from '@/lib/dateUtils.js'

const formatContracts = contracts => {
  return contracts.map(contract => {
    const jobs = contract.jobs.map(job => {
      return Object.assign(job, { searchConditionId: 0 })
    })
    return Object.assign(contract, { jobs: jobs })
  })
}

// 過去契約
const isPassed = lastDate => {
  return createDate(lastDate)?.isBefore(now(), 'days')
}

// 掲載期間中
const isPublished = (firstDate, lastDate) => {
  return now().isBetween(createDate(firstDate), createDate(lastDate), 'days', '[]')
}

// 未来契約
const isFeatured = firstDate => {
  return createDate(firstDate)?.isAfter(now(), 'days')
}

export default {
  namespaced: true,
  state: {
    contracts: []
  },
  mutations: {
    setContracts (state, { data }) {
      state.contracts = data
    },
    setSearchConditionId (state, { value, jobId }) {
      _(state.contracts).flatMap('jobs').filter({ id: jobId }).forEach(job => {
        Vue.set(job, 'searchConditionId', value)
      })
    },
    fetchScoutAmount (state, { contractId }) {
      const contract = _.find(state.contracts, { id: Number(contractId) })
      securedAxiosInstance.get(`/company/contracts/${Number(contractId)}/_scout_number_information`).then((response) => {
        Vue.set(contract, 'sentScoutAmount', response.data.sentScoutAmount)
        Vue.set(contract, 'reservedScoutFirstSendAmount', response.data.reservedScoutFirstSendAmount)
        Vue.set(contract, 'scoutLimit', response.data.scoutLimit)
      })
    },
    fetchLikeAmount (state, { contractId }) {
      const contract = _.find(state.contracts, { id: Number(contractId) })
      securedAxiosInstance.get(`/company/contracts/${Number(contractId)}/_like_number_information`).then((response) => {
        Vue.set(contract, 'likeLimit', response.data.likeLimit)
        Vue.set(contract, 'sentLikeAmount', response.data.sentLikeAmount)
      })
    },
    clearContracts (state) {
      Vue.set(state, 'contracts', [])
    }
  },
  actions: {
    storeContracts ({ commit, dispatch }) {
      securedAxiosInstance.get('/company/contracts').then((response) => {
        commit('setContracts', { data: formatContracts(response.data) })
      })
    },
    setSearchConditionId ({ commit }, { value, jobId }) {
      commit('setSearchConditionId', { value: value, jobId: Number(jobId) })
    },
    clearContracts ({ commit }) {
      commit('clearContracts')
    }
  },
  getters: {
    contracts: (state) => (id = '') => {
      return (id === '') ? state.contracts : _.defaultTo(_.find(state.contracts, { id: Number(id) }), {})
    },
    jobs (state) {
      return _(state.contracts).flatMap('jobs').value()
    },
    jobsBy: (state, getters) => (contractId) => {
      return getters.contracts(contractId).jobs
    },
    jobBy: (state, getters) => (contractId, jobId) => {
      return _.defaultTo(_.find(getters.jobsBy(contractId), { id: Number(jobId) }), {})
    },
    publishedJobsBy: (state, getters) => (contractId) => {
      return _(getters.contracts(contractId).jobs).filter(job => {
        return job.isPublished
      }).value()
    },
    publishedContracts (state) {
      return _(state.contracts).filter(contract => {
        return isPublished(contract.firstDate, contract.lastDate)
      }).value()
    },
    endContracts (state) {
      return _(state.contracts).filter(contract => {
        return isPassed(contract.lastDate)
      }).value()
    },
    featuredContracts (state) {
      return _(state.contracts).filter(contract => {
        return isFeatured(contract.firstDate)
      }).value()
    },
    isPublishedBy: (state, getters) => (contractId, jobId) => {
      const job = _.find(getters.contracts(contractId).jobs, { id: Number(jobId) })
      return job.isPublished
    },
    isFeaturedContract: (state) => (contractId) => {
      const contract = _(state.contracts).find(contract => contract.id === contractId)
      return isFeatured(_.get(contract, 'firstDate'))
    },
    hasEndedContract: (state) => (contractId) => {
      const contract = _(state.contracts).find(contract => contract.id === contractId)
      return isPassed(_.get(contract, 'lastDate'))
    },
    isLikeLimitOverBy: (state) => (contractId) => {
      const contract = _(state.contracts).find(contract => contract.id === contractId)
      return Number(contract.likeLimit - contract.sentLikeAmount) <= 0
    },
    canScoutResend: (state, getters) => (contractId, jobId) => {
      const scoutEndDate = _.defaultTo(_.find(getters.jobsBy(contractId), { id: Number(jobId) }).scoutEndDate, undefined)
      return scoutEndDate ? now().isSameOrBefore(createDate(scoutEndDate), 'days') : false
    }
  }
}
